import * as React from "react";

import { Portal } from "../../Common";

export const PortalToPaymentPageSideSection: React.FunctionComponent = (
  props
) => {
  return (
    <Portal
      selector={`
        .legacy-magento-checkout-container 
        > .legacy-magento-checkout-container-page-contents-container
        > .legacy-magento-checkout-container--portal-side
      `}
    >
      {props.children || []}
    </Portal>
  );
};
